import createSvgIcon from "./utils/create_icon"

const LockClosedFill = createSvgIcon(<path clipRule="evenodd" d="M7 10.17V7a5 5 0 0 1 10 0v3.17c1.165.413 2 1.524 2 2.83v6a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-6c0-1.306.835-2.417 2-2.83zM9 7a3 3 0 1 1 6 0v3H9zm1 9a2 2 0 1 1 4 0 2 2 0 0 1-4 0z" fill="currentColor" fillRule="evenodd" />, "LockClosedFill")
export default LockClosedFill
